









import Vue from 'vue'
import RouteAssistant from '@/helpers/route-assistant'
import ColorAssistant from '@/helpers/color-assistant'

export default Vue.extend({
  name: 'NewTaskButton',

  props: {
    projectId: {
      type: Number,
      default: null,
    },
    projectName: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'large',
    },
    disableClick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      RouteAssistant,
      ColorAssistant,
    }
  },
  methods: {
    handleClick() {
      if (this.disableClick) {
        return
      }
      if (this.projectId) {
        RouteAssistant.goToCreateTask(
          this.$router,
          this.$route.params.accountId,
          this.projectId,
          this.$permissions,
          this.projectName,
        )
      } else {
        RouteAssistant.goToGlobalCreateTask(
          this.$router,
          this.$route.params.accountId,
        )
      }
    },
  },
})
